import { inject, Injectable } from '@angular/core'
import { Router } from '@angular/router'
import { interval, Subscription, switchMap } from 'rxjs'
import { SessionService } from 'superlikers-microsites-api'

@Injectable({ providedIn: 'root' })
export class RequirementsMonitorService {
  private sessionService = inject(SessionService)
  private router = inject(Router)

  private checkInterval = 30000
  private subscription?: Subscription

  constructor() {
    this.startMonitoring()
  }

  private startMonitoring(): void {
    this.checkRequirements()

    this.subscription = interval(this.checkInterval)
      .pipe(switchMap(() => this.sessionService.checkRequirements()))
      .subscribe(result => {
        if (!result.allowed) {
          this.router.navigate([result.redirect_page])
        }
      })
  }

  stopMonitoring(): void {
    this.subscription?.unsubscribe()
  }

  private checkRequirements(): void {
    this.sessionService.checkRequirements().subscribe(result => {
      if (!result.allowed) {
        this.router.navigate([result.redirect_page])
      }
    })
  }
}
